"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/OrgSurvey/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _signup = require('shared/enum/signup');
var _types = require('web/screens/Signup/types');




var _onboardingAnalytics = require('web/services/onboardingAnalytics');



var _orgSurvey = require('shared/validation/org/orgSurvey');

var _ReferrerForm = require('./ReferrerForm'); var _ReferrerForm2 = _interopRequireDefault(_ReferrerForm);
var _ProductInterestForm = require('./ProductInterestForm'); var _ProductInterestForm2 = _interopRequireDefault(_ProductInterestForm);





// Legacy `features` are derived from the selected intent set so every existing
// consumer (SMS-popup listener, welcome-chat links, survey store, and the
// `org_survey_features` analytics property) keeps working with unchanged
// vocabulary. Each selected intent maps 1:1 to its legacy feature value.
const deriveFeatures = (productInterest) => {
  const features = []
  if (productInterest.includes(_signup.ProductInterest.SMS)) features.push(_signup.OrgSurveyFeature.SMS_MESSAGING)
  if (productInterest.includes(_signup.ProductInterest.TEAM_CHAT)) features.push(_signup.OrgSurveyFeature.TEAM_CHAT)
  if (productInterest.includes(_signup.ProductInterest.EXTERNAL_CHAT)) features.push(_signup.OrgSurveyFeature.EXTERNAL_CHAT)
  return features
}












const OrgSurveySection = ({
  onBack, onSubmit, answers, onAnswer, currentStep, gotoStep,
}) => {
  const { referrer, productInterest } = answers

  const onSaveReferrer = (data) => {
    onAnswer({ referrer: data })
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, 
      _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED,
      _onboardingAnalytics.getStepAnalyticsProperties.call(void 0, _types.SetupSteps.ORG_SURVEY_REFERRER),
    )
    gotoStep(_types.SetupSteps.PRODUCT_INTEREST)
  }

  const onSaveProductInterest = (interest) => {
    onAnswer({ productInterest: interest })
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, 
      _onboardingAnalytics.ONBOARDING_EVENTS.STEP_COMPLETED,
      _onboardingAnalytics.getStepAnalyticsProperties.call(void 0, _types.SetupSteps.PRODUCT_INTEREST),
    )
    if (!referrer || !interest.length) return
    return Promise.resolve(onSubmit({
      referrer: _orgSurvey.parseResponse.call(void 0, referrer),
      productInterest: interest,
      teamSize: '',
      patientsPerMonth: '',
      features: deriveFeatures(interest),
    }))
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  currentStep === _types.SetupSteps.ORG_SURVEY_REFERRER && (
        _react2.default.createElement(_ReferrerForm2.default, {
          defaultValues: referrer,
          onBack: onBack,
          onSubmit: onSaveReferrer, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
        )
      )
      ,  currentStep === _types.SetupSteps.PRODUCT_INTEREST && (
        _react2.default.createElement(_ProductInterestForm2.default, {
          value: productInterest,
          onChange: interest => onAnswer({ productInterest: interest }),
          onBack: onBack,
          onSubmit: onSaveProductInterest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
        )
      )
    )
  )
}

exports. default = OrgSurveySection
